// @flow

// Modules
import React from 'react';
import styled from 'styled-components';

// Styles
import { BLUE_GREY, WHITE } from 'src/styles/palettes';

// Methods
import Formatter from 'src/methods/formatter';

// Assets
import { ChevronLeft, ChevronRight } from 'assets/svg';

/**
 * Styles
 */

const DatePickerRoot = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  flex: 0.9;
  align-items: center;
  height: 100%;
  border-radius: 6px;
  background-color: ${BLUE_GREY[700]};
`;

const SideArrow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 80%;
  margin: 4px;
  border-radius: 5px;
  background-color: ${BLUE_GREY[500]};
  cursor: ${(props) => (props.isVisible ? 'pointer' : 'auto')};
  ${(props) => !props.isVisible && 'opacity: 0;'}
`;

const DateLabel = styled.div`
  flex: 1;
  align-items: center;
  color: ${WHITE};
  text-align: center;
`;

const ChevronLeftSvg = styled(ChevronLeft)`
  height: 1em;
  width: 1em;
`;

const ChevronRightSvg = styled(ChevronRight)`
  height: 1em;
  width: 1em;
`;

/**
 * Types
 */

type PropTypes = {
  className?: any,
  selectedDate: number,
  dates: Array<number>,
  onItemClick: (id: number) => void
};

/*
 ** Component
 */

const DatePicker = (props: PropTypes): any => {
  const { className, dates, selectedDate, onItemClick } = props;
  const hasLeftArrow = dates && selectedDate !== dates.length - 1;
  const hasRightArrow = selectedDate !== 0;
  const dateTs = dates && dates[selectedDate];
  const dateValue = dateTs ? Formatter.formatDate(dateTs, 'shortday') : '';

  const renderArrow = (isVisible: boolean, onClick: function, isLeft?: boolean) => {
    return (
      <SideArrow isLeft={isLeft} isVisible={isVisible} onClick={isVisible ? onClick : null}>
        {isLeft ? <ChevronLeftSvg /> : <ChevronRightSvg />}
      </SideArrow>
    );
  };

  return (
    <DatePickerRoot className={className}>
      {renderArrow(hasLeftArrow, () => onItemClick(selectedDate + 1), true)}
      <DateLabel>{dateValue}</DateLabel>
      {renderArrow(hasRightArrow, () => onItemClick(selectedDate - 1))}
    </DatePickerRoot>
  );
};

export default DatePicker;
